import React from "react";
import { footerConfig } from "./footerConfig";
import { useToggle } from "./useToggle";
import { PoliticaProteccionComponent } from "./PoliticaProteccion";
import { TerminosCondicionesComponent } from "./TerminosCondiciones";
import IconFb from "./assets/redes/Facebook.png";
import IconInsta from "./assets/redes/Instagram.png";
import IconLinkedin from "./assets/redes/LinkedIn.png";
import IconTw from "./assets/redes/Xfooter.svg";
import FooterLocationPin from "./assets/footer-location-pin.png";
import FooterPhone from "./assets/footer-phone.png";
import LogoFooter from "./assets/logo-hb-blak.png";
import "./footer.css";

const RECLAMOS_URL = "https://autogestion.produccion.gob.ar/consumidores";

export default function Footer() {
  const politicaToggle = useToggle();
  const terminosToggle = useToggle();

  return (
    <section className="section-footer" style={{ minHeight: "200px" }}>
      <div className="footer-wrap">
        <div className="footer-row pt-3 pb-2">
          <div className="footer-col">
            <div className="footer-col-inner">
            <p className="d-flex align-items-center">
              <img
                src={LogoFooter}
                alt="logo footer"
                style={{ paddingRight: "5px", height: "16px" }}
              />
              <span className="section-footer__titulo">
                {`Hospital Británico | © ${new Date().getFullYear()}`}
              </span>
            </p>

            <p className="section-footer__texto-PSHB">
              Sr. Consumidor o usuario: ante cualquier duda o reclamo diríjase
              al área de defensa y protección al consumidor de cualquier Centro
              de Gestión y participación Comunal (CGPC) del Gobierno de la ciudad
              Autónoma de Buenos Aires.
              <br />
              <br />
              R.N.E.M.P N° 1255 - RNAS 9-0250-4 Superintendencia de Servicios de
              Salud 0800-222-SALUD (72583).{" "}
              <a
                href="https://www.argentina.gob.ar/sssalud"
                target="_blank"
                rel="noreferrer"
              >
                www.sssalud.gob.ar
              </a>
            </p>
            <p className="section-footer__texto">
              Defensa de las y los consumidores. Para reclamos ingrese{" "}
              <a
                href={RECLAMOS_URL}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#004990", textDecoration: "underline", cursor: "pointer" }}
              >
                aquí.
              </a>
            </p>
            </div>
          </div>

          <div className="footer-col">
            <div className="d-flex contact-social-networks">
              <div className="icons d-flex align-items-center">
                <a
                  id="socialIcon"
                  href={footerConfig.facebook}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={IconFb}
                    className="img-fluid px-1 footer-icon"
                    alt="Facebook"
                  />
                </a>
                <a
                  id="socialIcon"
                  href={footerConfig.twitter}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={IconTw}
                    className="img-fluid px-1 footer-icon"
                    alt="Twitter"
                  />
                </a>
                <a
                  id="socialIcon"
                  href={footerConfig.linkedin}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={IconLinkedin}
                    className="img-fluid px-1 footer-icon"
                    alt="LinkedIn"
                  />
                </a>
                <a
                  id="socialIcon"
                  href={footerConfig.instagram}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={IconInsta}
                    className="img-fluid px-1 footer-icon"
                    alt="Instagram"
                  />
                </a>
              </div>
              <div className="section-footer__privacidad">
                <span className="section-footer__texto">
                  <span>
                    <button
                      type="button"
                      className="footer-btn"
                      onClick={politicaToggle.onToggle}
                    >
                      POLÍTICA DE PRIVACIDAD
                    </button>
                  </span>
                  <span>
                    {" "}
                    <button
                      type="button"
                      className="footer-btn"
                      onClick={terminosToggle.onToggle}
                    >
                      | TÉRMINOS Y CONDICIONES
                    </button>
                  </span>
                  <span>
                    {" "}
                    <span className="footer-btn footer-btn-pointer">
                      {" "}
                      |{" "}
                      <a
                        target="_blank"
                        className="link-default"
                        rel="noreferrer"
                        href={footerConfig.intranet}
                      >
                        INTRANET
                      </a>
                    </span>
                  </span>
                </span>
                <PoliticaProteccionComponent
                  visible={politicaToggle.toggle}
                  onToggle={politicaToggle.onToggle}
                />
                <TerminosCondicionesComponent
                  visible={terminosToggle.toggle}
                  onToggle={terminosToggle.onToggle}
                />
              </div>
            </div>
            <div className="footer-row">
              <div className="footer-col">
                <div className="d-flex flex-column mx-2 mt-3 contact-information">
                  <div className="icon-location">
                    <img
                      src={FooterLocationPin}
                      className="img-fluid"
                      alt="ubicación"
                    />
                    <a
                      href={footerConfig.ubicacion}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="ms-2 section-footer__texto">
                        {footerConfig.direccion_domicilio}
                      </span>
                    </a>
                  </div>
                  <div className="icon-phone" style={{ marginTop: "5px" }}>
                    <img
                      src={FooterPhone}
                      className="img-fluid"
                      alt="teléfono"
                    />
                    <a href={`tel:${footerConfig.telefono_domicilio}`}>
                      <span className="ms-2 section-footer__texto">
                        {footerConfig.telefono_domicilio}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
